import React, { useCallback, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { ContainerClients } from './style.js';

import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';

const FlagHistoryAdd = () => {
  document.title = 'Datamais - Cadastrar Histórico de Bandeira';

  const navigate = useNavigate();

  const [idDm004, setIdDm004] = useState(0);
  const [idDm004List, setIdDm004List] = useState(0);
  const [vlBandeira, setVlBandeira] = useState('');
  const [dtBandeira, setDtBandeira] = useState('');

  const handleSendFlagHist = useCallback(async () => {
    const data = {
      ID_DM004: parseInt(idDm004),
      DT_COMPETENCIA: dtBandeira,
      VL_ADICIONAL_BANDEIRA: parseFloat(vlBandeira.replace(',', '.'))
    };
    api
      .post(`flag_history`, data)
      .then((response) => {
        if (response.status === 201) {
          toast.success('Histórico de Bandeira adicionado com sucesso!', {
            autoClose: 3000,
            onClose: () => {
              navigate('/flag_hist/list');
            }
          });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response.data.error);
        toast.error(error.response.data.message);
      });
  }, [idDm004, vlBandeira, dtBandeira]);

  useEffect(() => {
    api
      .get(`energy_flag`)
      .then((response) => {
        if (response.status === 200) {
          setIdDm004List(response.data.data);
          setIdDm004(response.data.data[0].ID_DM004);
          setDtBandeira(new Date().toISOString().split('T')[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <AuthGuard />
      <Container>
        <Menu />
        <ContainerClients>
          <h2>Cadastrar Histórico de Bandeira</h2>
          <Row>
            <div
              style={{
                border: '1px solid',
                borderRadius: '10px',
                marginTop: '30px'
              }}>
              <p
                style={{
                  marginTop: '-12px',
                  background: '#f1f1f1',
                  display: 'table',
                  padding: '0px 5px 0px 5px'
                }}>
                Dados da Tarifa
              </p>
              <Row>
                <Col xs={3}>
                  <SelectDefault
                    Text="Bandeira"
                    Margin={'15px 15px 15px 0px'}
                    Width={'100%'}
                    value={idDm004}
                    onChange={(e) => setIdDm004(e.target.value)}>
                    {idDm004List && idDm004List.length > 0 ? (
                      idDm004List.map((item) => (
                        <option key={item.ID_DM004} value={item.ID_DM004}>
                          {item.NM_BANDEIRA} ({item.ID_DM004})
                        </option>
                      ))
                    ) : (
                      <option disabled>Carregando lista...</option>
                    )}
                  </SelectDefault>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <InputDefault
                    placeholder="Valor adicional da bandeira"
                    Width={'100%'}
                    Margin={'15px 15px 15px 0px'}
                    value={vlBandeira}
                    onChange={(e) => setVlBandeira(e.target.value)}
                    Text={'Valor adicional da bandeira'}
                    type={'number'}
                  />
                </Col>
                <Col xs={12} md={2}>
                  <InputDefault
                    placeholder="Data de"
                    Width={'100%'}
                    Margin={'10px 0px 15px 0px'}
                    Text={'Data de'}
                    type="date"
                    value={`${dtBandeira}`}
                    onChange={(e) => setDtBandeira(e.target.value)}
                  />
                </Col>
              </Row>
            </div>
          </Row>
          <Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Salvar"
              onClick={() => {
                handleSendFlagHist();
              }}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Cancelar"
              onClick={() => {
                navigate('/flag_hist/list');
              }}
            />
          </Row>
        </ContainerClients>
        <ToastContainer />
      </Container>
      <Footer />
    </>
  );
};

export default FlagHistoryAdd;
